(function () {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kPatientAlert
   * @restrict E
   * @scope
   * @description
   * Only displays if a patient has an alert of the specified type
   *
   * @param {String} patientGuid patients guid
   * @param {String} alertSetting Alert type
   * @example
   <example module="kareo.ui.shared.directives.k-patient-alert">
   <file name="index.html">
   <div></div>
   Patient Guid: <input ng-model="patientGuidInput">
   <button ng-click="patientGuid = patientGuidInput">Set Patient Guid</button>
    <k-patient-alert patient-guid="patientGuid" alert-setting="showInPatient"></k-patient-alert>
   </file>
   </example>
   */

  const PATIENT_ALERTS_FEATURE = 'dark-feature.patient-alerts';

  angular
    .module('kareo.ui.shared.directives.k-patient-alert', [
      'kareo.ui.shared.modules.api.k-patient-alert-service',
      'kareo.ui.shared.modules.featureSet',
      'kareo.ui.shared.directives.templates'
    ])
    .directive('kPatientAlert', kPatientAlert);

  kPatientAlert.$inject = ['$timeout', 'kPatientAlertService', 'featureSet'];

  function kPatientAlert($timeout, kPatientAlertService, featureSet) {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {
        patientGuid: '=',
        alertSetting: '@'
      },
      link: function link(scope, elem, attrs) {
        loadAlert();

        scope.$watch('vm.patientGuid', (newVal, oldVal) => {
          if (newVal !== oldVal) {
            loadAlert();
          }
        });

        function loadAlert() {
          if (scope.vm.patientGuid === undefined) {
            scope.vm.patientAlert = '';
            return;
          }

          featureSet.load()
            .then((features) => {
              if (!!features[PATIENT_ALERTS_FEATURE]) {
                kPatientAlertService.getPatientAlert(scope.vm.patientGuid)
                  .then((response) => {
                    if (response !== null && response[scope.vm.alertSetting]) {
                      scope.vm.patientAlert = response.alertMessage;
                      // DOM will not update until thread returns
                      // and offsetHeight of hidden elements is always 0
                      $timeout(() => {
                        checkExpansion();
                      }, 0);
                    }
                  });

                //  we don't specify an error function because
                // in the case of an error, simply not setting patientAlert
                // will cause no alert to show, which is what we want
              }
            });
        }

        function checkExpansion() {
          const newHeight = elem[0].querySelector('.alert-message').offsetHeight;
          scope.vm.needsExpansion = (newHeight > 72);
        }
      },
      template: require('./k-patient-alert.pug')()
    };
  }

  function controller() {
    var vm = this;

    vm.showMore = false;
    vm.needsExpansion = false; //  this will eventually be used to hide the show more when there is no more text to show
  }
})();
